import { useEffect } from "react";
import { readPairingTicket, type ListedConnector } from "../../../api/connectorsApi";
import { readPairingTicketId, writePairingTicketId } from "./thisPc";

/**
 * The PC this browser's "Connect this PC" link paired with its ticket (F122) is the one it is
 * on (W-06): once the server says which, `onPaired` marks it, also over an older mark. It asks
 * when the page shows its PCs and again whenever they change, as when that PC appears. A ticket
 * that paired nothing and never will is forgotten; one still waiting is asked about next time.
 */
export function usePairedHere(userId: string, pcs: readonly ListedConnector[], onPaired: (connectorId: string) => void): void {
  const pcIds = pcs.map((pc) => pc.connectorId).join(" ");
  useEffect(() => {
    const ticketId = readPairingTicketId(userId);
    if (ticketId === null) return undefined;
    const controller = new AbortController();
    readPairingTicket(ticketId, controller.signal).then(
      ({ state, connectorId }) => {
        if (state === "pending") return;
        writePairingTicketId(userId, null);
        if (connectorId !== null) onPaired(connectorId);
      },
      // Not answered now (offline, or gone); asked again next time, until it expires there.
      () => undefined,
    );
    return () => { controller.abort(); };
  }, [userId, pcIds, onPaired]);
}
